import type { TaxonomyNode, TaxonomySubject } from './taxonomy.mock';

type ChineseTaxonomyCsvRow = {
  difficulty: string;
  targetGrade: string;
  topicTypeId: string;
  topic: string;
  subject: string;
  learningDomain: string;
  learningUnit: string;
  topicGrade: string;
  performanceIndicator: string;
  id: string;
};

const CHINESE_TAXONOMY_CSV = `difficulty,target_grade,topic_type_id,topic,subject,learning_domain,learning_unit,topic_grade,performance_indicator,id
1,k1,1001,環境聲音,chinese,語音與聆聽,聲音辨識,K1,能聆聽並辨識「環境聲音」相關聲音、詞語或圖片。,500001
2,k1,1001,環境聲音,chinese,語音與聆聽,聲音辨識,K1,能根據聆聽內容配對、分類或選出與「環境聲音」相關的答案。,500002
3,k1,1001,環境聲音,chinese,語音與聆聽,聲音辨識,K1,能理解短句或短故事中與「環境聲音」相關的重點或次序。,500003
1,k1,1002,動物叫聲,chinese,語音與聆聽,聲音辨識,K1,能聆聽並辨識「動物叫聲」相關聲音、詞語或圖片。,500004
2,k1,1002,動物叫聲,chinese,語音與聆聽,聲音辨識,K1,能根據聆聽內容配對、分類或選出與「動物叫聲」相關的答案。,500005
3,k1,1002,動物叫聲,chinese,語音與聆聽,聲音辨識,K1,能理解短句或短故事中與「動物叫聲」相關的重點或次序。,500006
1,k1,1003,物件聲音,chinese,語音與聆聽,聲音辨識,K1,能聆聽並辨識「物件聲音」相關聲音、詞語或圖片。,500007
2,k1,1003,物件聲音,chinese,語音與聆聽,聲音辨識,K1,能根據聆聽內容配對、分類或選出與「物件聲音」相關的答案。,500008
3,k1,1003,物件聲音,chinese,語音與聆聽,聲音辨識,K1,能理解短句或短故事中與「物件聲音」相關的重點或次序。,500009
1,k2,1004,相同聲音與不同聲音,chinese,語音與聆聽,聲音辨識,K2,能聆聽並辨識「相同聲音與不同聲音」相關聲音、詞語或圖片。,500010
2,k2,1004,相同聲音與不同聲音,chinese,語音與聆聽,聲音辨識,K2,能根據聆聽內容配對、分類或選出與「相同聲音與不同聲音」相關的答案。,500011
3,k2,1004,相同聲音與不同聲音,chinese,語音與聆聽,聲音辨識,K2,能理解短句或短故事中與「相同聲音與不同聲音」相關的重點或次序。,500012
1,k2,1005,聲音來源,chinese,語音與聆聽,聲音辨識,K2,能聆聽並辨識「聲音來源」相關聲音、詞語或圖片。,500013
2,k2,1005,聲音來源,chinese,語音與聆聽,聲音辨識,K2,能根據聆聽內容配對、分類或選出與「聲音來源」相關的答案。,500014
3,k2,1005,聲音來源,chinese,語音與聆聽,聲音辨識,K2,能理解短句或短故事中與「聲音來源」相關的重點或次序。,500015
1,k2,1006,詞語首音,chinese,語音與聆聽,聲音辨識,K2,能聆聽並辨識「詞語首音」相關聲音、詞語或圖片。,500016
2,k2,1006,詞語首音,chinese,語音與聆聽,聲音辨識,K2,能根據聆聽內容配對、分類或選出與「詞語首音」相關的答案。,500017
3,k2,1006,詞語首音,chinese,語音與聆聽,聲音辨識,K2,能理解短句或短故事中與「詞語首音」相關的重點或次序。,500018
1,k3,1007,聲調辨識,chinese,語音與聆聽,聲音辨識,K3,能聆聽並辨識「聲調辨識」相關聲音、詞語或圖片。,500019
2,k3,1007,聲調辨識,chinese,語音與聆聽,聲音辨識,K3,能根據聆聽內容配對、分類或選出與「聲調辨識」相關的答案。,500020
3,k3,1007,聲調辨識,chinese,語音與聆聽,聲音辨識,K3,能理解短句或短故事中與「聲調辨識」相關的重點或次序。,500021
1,k3,1008,相近讀音,chinese,語音與聆聽,聲音辨識,K3,能聆聽並辨識「相近讀音」相關聲音、詞語或圖片。,500022
2,k3,1008,相近讀音,chinese,語音與聆聽,聲音辨識,K3,能根據聆聽內容配對、分類或選出與「相近讀音」相關的答案。,500023
3,k3,1008,相近讀音,chinese,語音與聆聽,聲音辨識,K3,能理解短句或短故事中與「相近讀音」相關的重點或次序。,500024
1,k3,1009,押韻詞,chinese,語音與聆聽,聲音辨識,K3,能聆聽並辨識「押韻詞」相關聲音、詞語或圖片。,500025
2,k3,1009,押韻詞,chinese,語音與聆聽,聲音辨識,K3,能根據聆聽內容配對、分類或選出與「押韻詞」相關的答案。,500026
3,k3,1009,押韻詞,chinese,語音與聆聽,聲音辨識,K3,能理解短句或短故事中與「押韻詞」相關的重點或次序。,500027
1,k1,1010,一步指令,chinese,語音與聆聽,聆聽指令,K1,能聆聽並辨識「一步指令」相關聲音、詞語或圖片。,500028
2,k1,1010,一步指令,chinese,語音與聆聽,聆聽指令,K1,能根據聆聽內容配對、分類或選出與「一步指令」相關的答案。,500029
3,k1,1010,一步指令,chinese,語音與聆聽,聆聽指令,K1,能理解短句或短故事中與「一步指令」相關的重點或次序。,500030
1,k1,1011,動作指令,chinese,語音與聆聽,聆聽指令,K1,能聆聽並辨識「動作指令」相關聲音、詞語或圖片。,500031
2,k1,1011,動作指令,chinese,語音與聆聽,聆聽指令,K1,能根據聆聽內容配對、分類或選出與「動作指令」相關的答案。,500032
3,k1,1011,動作指令,chinese,語音與聆聽,聆聽指令,K1,能理解短句或短故事中與「動作指令」相關的重點或次序。,500033
1,k2,1012,兩步指令,chinese,語音與聆聽,聆聽指令,K2,能聆聽並辨識「兩步指令」相關聲音、詞語或圖片。,500034
2,k2,1012,兩步指令,chinese,語音與聆聽,聆聽指令,K2,能根據聆聽內容配對、分類或選出與「兩步指令」相關的答案。,500035
3,k2,1012,兩步指令,chinese,語音與聆聽,聆聽指令,K2,能理解短句或短故事中與「兩步指令」相關的重點或次序。,500036
1,k2,1013,方位指令,chinese,語音與聆聽,聆聽指令,K2,能聆聽並辨識「方位指令」相關聲音、詞語或圖片。,500037
2,k2,1013,方位指令,chinese,語音與聆聽,聆聽指令,K2,能根據聆聽內容配對、分類或選出與「方位指令」相關的答案。,500038
3,k2,1013,方位指令,chinese,語音與聆聽,聆聽指令,K2,能理解短句或短故事中與「方位指令」相關的重點或次序。,500039
1,k3,1014,三步指令,chinese,語音與聆聽,聆聽指令,K3,能聆聽並辨識「三步指令」相關聲音、詞語或圖片。,500040
2,k3,1014,三步指令,chinese,語音與聆聽,聆聽指令,K3,能根據聆聽內容配對、分類或選出與「三步指令」相關的答案。,500041
3,k3,1014,三步指令,chinese,語音與聆聽,聆聽指令,K3,能理解短句或短故事中與「三步指令」相關的重點或次序。,500042
1,k3,1015,條件指令,chinese,語音與聆聽,聆聽指令,K3,能聆聽並辨識「條件指令」相關聲音、詞語或圖片。,500043
2,k3,1015,條件指令,chinese,語音與聆聽,聆聽指令,K3,能根據聆聽內容配對、分類或選出與「條件指令」相關的答案。,500044
3,k3,1015,條件指令,chinese,語音與聆聽,聆聽指令,K3,能理解短句或短故事中與「條件指令」相關的重點或次序。,500045
1,k1,1016,聽詞選圖,chinese,語音與聆聽,聆聽理解,K1,能聆聽並辨識「聽詞選圖」相關聲音、詞語或圖片。,500046
2,k1,1016,聽詞選圖,chinese,語音與聆聽,聆聽理解,K1,能根據聆聽內容配對、分類或選出與「聽詞選圖」相關的答案。,500047
3,k1,1016,聽詞選圖,chinese,語音與聆聽,聆聽理解,K1,能理解短句或短故事中與「聽詞選圖」相關的重點或次序。,500048
1,k1,1017,聽短句選圖,chinese,語音與聆聽,聆聽理解,K1,能聆聽並辨識「聽短句選圖」相關聲音、詞語或圖片。,500049
2,k1,1017,聽短句選圖,chinese,語音與聆聽,聆聽理解,K1,能根據聆聽內容配對、分類或選出與「聽短句選圖」相關的答案。,500050
3,k1,1017,聽短句選圖,chinese,語音與聆聽,聆聽理解,K1,能理解短句或短故事中與「聽短句選圖」相關的重點或次序。,500051
1,k2,1018,聽故事找人物,chinese,語音與聆聽,聆聽理解,K2,能聆聽並辨識「聽故事找人物」相關聲音、詞語或圖片。,500052
2,k2,1018,聽故事找人物,chinese,語音與聆聽,聆聽理解,K2,能根據聆聽內容配對、分類或選出與「聽故事找人物」相關的答案。,500053
3,k2,1018,聽故事找人物,chinese,語音與聆聽,聆聽理解,K2,能理解短句或短故事中與「聽故事找人物」相關的重點或次序。,500054
1,k2,1019,聽故事找地點,chinese,語音與聆聽,聆聽理解,K2,能聆聽並辨識「聽故事找地點」相關聲音、詞語或圖片。,500055
2,k2,1019,聽故事找地點,chinese,語音與聆聽,聆聽理解,K2,能根據聆聽內容配對、分類或選出與「聽故事找地點」相關的答案。,500056
3,k2,1019,聽故事找地點,chinese,語音與聆聽,聆聽理解,K2,能理解短句或短故事中與「聽故事找地點」相關的重點或次序。,500057
1,k2,1020,聽故事排序,chinese,語音與聆聽,聆聽理解,K2,能聆聽並辨識「聽故事排序」相關聲音、詞語或圖片。,500058
2,k2,1020,聽故事排序,chinese,語音與聆聽,聆聽理解,K2,能根據聆聽內容配對、分類或選出與「聽故事排序」相關的答案。,500059
3,k2,1020,聽故事排序,chinese,語音與聆聽,聆聽理解,K2,能理解短句或短故事中與「聽故事排序」相關的重點或次序。,500060
1,k3,1021,聽故事原因結果,chinese,語音與聆聽,聆聽理解,K3,能聆聽並辨識「聽故事原因結果」相關聲音、詞語或圖片。,500061
2,k3,1021,聽故事原因結果,chinese,語音與聆聽,聆聽理解,K3,能根據聆聽內容配對、分類或選出與「聽故事原因結果」相關的答案。,500062
3,k3,1021,聽故事原因結果,chinese,語音與聆聽,聆聽理解,K3,能理解短句或短故事中與「聽故事原因結果」相關的重點或次序。,500063
1,k3,1022,聽故事主旨,chinese,語音與聆聽,聆聽理解,K3,能聆聽並辨識「聽故事主旨」相關聲音、詞語或圖片。,500064
2,k3,1022,聽故事主旨,chinese,語音與聆聽,聆聽理解,K3,能根據聆聽內容配對、分類或選出與「聽故事主旨」相關的答案。,500065
3,k3,1022,聽故事主旨,chinese,語音與聆聽,聆聽理解,K3,能理解短句或短故事中與「聽故事主旨」相關的重點或次序。,500066
1,k3,1023,聽故事情緒,chinese,語音與聆聽,聆聽理解,K3,能聆聽並辨識「聽故事情緒」相關聲音、詞語或圖片。,500067
2,k3,1023,聽故事情緒,chinese,語音與聆聽,聆聽理解,K3,能根據聆聽內容配對、分類或選出與「聽故事情緒」相關的答案。,500068
3,k3,1023,聽故事情緒,chinese,語音與聆聽,聆聽理解,K3,能理解短句或短故事中與「聽故事情緒」相關的重點或次序。,500069
1,k1,1024,打招呼,chinese,口語表達,生活口語,K1,能用詞語或短句表達「打招呼」相關內容。,500070
2,k1,1024,打招呼,chinese,口語表達,生活口語,K1,能按圖片或情境說出與「打招呼」相關的完整句。,500071
3,k1,1024,打招呼,chinese,口語表達,生活口語,K1,能在簡單對話或故事情境中表達與「打招呼」相關的想法。,500072
1,k1,1025,表達需要,chinese,口語表達,生活口語,K1,能用詞語或短句表達「表達需要」相關內容。,500073
2,k1,1025,表達需要,chinese,口語表達,生活口語,K1,能按圖片或情境說出與「表達需要」相關的完整句。,500074
3,k1,1025,表達需要,chinese,口語表達,生活口語,K1,能在簡單對話或故事情境中表達與「表達需要」相關的想法。,500075
1,k1,1026,自我介紹,chinese,口語表達,生活口語,K1,能用詞語或短句表達「自我介紹」相關內容。,500076
2,k1,1026,自我介紹,chinese,口語表達,生活口語,K1,能按圖片或情境說出與「自我介紹」相關的完整句。,500077
3,k1,1026,自我介紹,chinese,口語表達,生活口語,K1,能在簡單對話或故事情境中表達與「自我介紹」相關的想法。,500078
1,k2,1027,禮貌用語,chinese,口語表達,生活口語,K2,能用詞語或短句表達「禮貌用語」相關內容。,500079
2,k2,1027,禮貌用語,chinese,口語表達,生活口語,K2,能按圖片或情境說出與「禮貌用語」相關的完整句。,500080
3,k2,1027,禮貌用語,chinese,口語表達,生活口語,K2,能在簡單對話或故事情境中表達與「禮貌用語」相關的想法。,500081
1,k2,1028,描述喜好,chinese,口語表達,生活口語,K2,能用詞語或短句表達「描述喜好」相關內容。,500082
2,k2,1028,描述喜好,chinese,口語表達,生活口語,K2,能按圖片或情境說出與「描述喜好」相關的完整句。,500083
3,k2,1028,描述喜好,chinese,口語表達,生活口語,K2,能在簡單對話或故事情境中表達與「描述喜好」相關的想法。,500084
1,k2,1029,描述感受,chinese,口語表達,生活口語,K2,能用詞語或短句表達「描述感受」相關內容。,500085
2,k2,1029,描述感受,chinese,口語表達,生活口語,K2,能按圖片或情境說出與「描述感受」相關的完整句。,500086
3,k2,1029,描述感受,chinese,口語表達,生活口語,K2,能在簡單對話或故事情境中表達與「描述感受」相關的想法。,500087
1,k3,1030,完整回答,chinese,口語表達,生活口語,K3,能用詞語或短句表達「完整回答」相關內容。,500088
2,k3,1030,完整回答,chinese,口語表達,生活口語,K3,能按圖片或情境說出與「完整回答」相關的完整句。,500089
3,k3,1030,完整回答,chinese,口語表達,生活口語,K3,能在簡單對話或故事情境中表達與「完整回答」相關的想法。,500090
1,k3,1031,提出問題,chinese,口語表達,生活口語,K3,能用詞語或短句表達「提出問題」相關內容。,500091
2,k3,1031,提出問題,chinese,口語表達,生活口語,K3,能按圖片或情境說出與「提出問題」相關的完整句。,500092
3,k3,1031,提出問題,chinese,口語表達,生活口語,K3,能在簡單對話或故事情境中表達與「提出問題」相關的想法。,500093
1,k3,1032,簡單原因說明,chinese,口語表達,生活口語,K3,能用詞語或短句表達「簡單原因說明」相關內容。,500094
2,k3,1032,簡單原因說明,chinese,口語表達,生活口語,K3,能按圖片或情境說出與「簡單原因說明」相關的完整句。,500095
3,k3,1032,簡單原因說明,chinese,口語表達,生活口語,K3,能在簡單對話或故事情境中表達與「簡單原因說明」相關的想法。,500096
1,k1,1033,命名物件,chinese,口語表達,圖片描述,K1,能用詞語或短句表達「命名物件」相關內容。,500097
2,k1,1033,命名物件,chinese,口語表達,圖片描述,K1,能按圖片或情境說出與「命名物件」相關的完整句。,500098
3,k1,1033,命名物件,chinese,口語表達,圖片描述,K1,能在簡單對話或故事情境中表達與「命名物件」相關的想法。,500099
1,k1,1034,描述顏色,chinese,口語表達,圖片描述,K1,能用詞語或短句表達「描述顏色」相關內容。,500100
2,k1,1034,描述顏色,chinese,口語表達,圖片描述,K1,能按圖片或情境說出與「描述顏色」相關的完整句。,500101
3,k1,1034,描述顏色,chinese,口語表達,圖片描述,K1,能在簡單對話或故事情境中表達與「描述顏色」相關的想法。,500102
1,k1,1035,描述大小,chinese,口語表達,圖片描述,K1,能用詞語或短句表達「描述大小」相關內容。,500103
2,k1,1035,描述大小,chinese,口語表達,圖片描述,K1,能按圖片或情境說出與「描述大小」相關的完整句。,500104
3,k1,1035,描述大小,chinese,口語表達,圖片描述,K1,能在簡單對話或故事情境中表達與「描述大小」相關的想法。,500105
1,k2,1036,描述動作,chinese,口語表達,圖片描述,K2,能用詞語或短句表達「描述動作」相關內容。,500106
2,k2,1036,描述動作,chinese,口語表達,圖片描述,K2,能按圖片或情境說出與「描述動作」相關的完整句。,500107
3,k2,1036,描述動作,chinese,口語表達,圖片描述,K2,能在簡單對話或故事情境中表達與「描述動作」相關的想法。,500108
1,k2,1037,描述位置,chinese,口語表達,圖片描述,K2,能用詞語或短句表達「描述位置」相關內容。,500109
2,k2,1037,描述位置,chinese,口語表達,圖片描述,K2,能按圖片或情境說出與「描述位置」相關的完整句。,500110
3,k2,1037,描述位置,chinese,口語表達,圖片描述,K2,能在簡單對話或故事情境中表達與「描述位置」相關的想法。,500111
1,k2,1038,描述數量,chinese,口語表達,圖片描述,K2,能用詞語或短句表達「描述數量」相關內容。,500112
2,k2,1038,描述數量,chinese,口語表達,圖片描述,K2,能按圖片或情境說出與「描述數量」相關的完整句。,500113
3,k2,1038,描述數量,chinese,口語表達,圖片描述,K2,能在簡單對話或故事情境中表達與「描述數量」相關的想法。,500114
1,k3,1039,描述情境,chinese,口語表達,圖片描述,K3,能用詞語或短句表達「描述情境」相關內容。,500115
2,k3,1039,描述情境,chinese,口語表達,圖片描述,K3,能按圖片或情境說出與「描述情境」相關的完整句。,500116
3,k3,1039,描述情境,chinese,口語表達,圖片描述,K3,能在簡單對話或故事情境中表達與「描述情境」相關的想法。,500117
1,k3,1040,比較兩幅圖,chinese,口語表達,圖片描述,K3,能用詞語或短句表達「比較兩幅圖」相關內容。,500118
2,k3,1040,比較兩幅圖,chinese,口語表達,圖片描述,K3,能按圖片或情境說出與「比較兩幅圖」相關的完整句。,500119
3,k3,1040,比較兩幅圖,chinese,口語表達,圖片描述,K3,能在簡單對話或故事情境中表達與「比較兩幅圖」相關的想法。,500120
1,k3,1041,看圖說完整句,chinese,口語表達,圖片描述,K3,能用詞語或短句表達「看圖說完整句」相關內容。,500121
2,k3,1041,看圖說完整句,chinese,口語表達,圖片描述,K3,能按圖片或情境說出與「看圖說完整句」相關的完整句。,500122
3,k3,1041,看圖說完整句,chinese,口語表達,圖片描述,K3,能在簡單對話或故事情境中表達與「看圖說完整句」相關的想法。,500123
1,k1,1042,看圖說一句,chinese,口語表達,故事表達,K1,能用詞語或短句表達「看圖說一句」相關內容。,500124
2,k1,1042,看圖說一句,chinese,口語表達,故事表達,K1,能按圖片或情境說出與「看圖說一句」相關的完整句。,500125
3,k1,1042,看圖說一句,chinese,口語表達,故事表達,K1,能在簡單對話或故事情境中表達與「看圖說一句」相關的想法。,500126
1,k1,1043,人物命名,chinese,口語表達,故事表達,K1,能用詞語或短句表達「人物命名」相關內容。,500127
2,k1,1043,人物命名,chinese,口語表達,故事表達,K1,能按圖片或情境說出與「人物命名」相關的完整句。,500128
3,k1,1043,人物命名,chinese,口語表達,故事表達,K1,能在簡單對話或故事情境中表達與「人物命名」相關的想法。,500129
1,k2,1044,圖卡排序說話,chinese,口語表達,故事表達,K2,能用詞語或短句表達「圖卡排序說話」相關內容。,500130
2,k2,1044,圖卡排序說話,chinese,口語表達,故事表達,K2,能按圖片或情境說出與「圖卡排序說話」相關的完整句。,500131
3,k2,1044,圖卡排序說話,chinese,口語表達,故事表達,K2,能在簡單對話或故事情境中表達與「圖卡排序說話」相關的想法。,500132
1,k2,1045,二至三句復述,chinese,口語表達,故事表達,K2,能用詞語或短句表達「二至三句復述」相關內容。,500133
2,k2,1045,二至三句復述,chinese,口語表達,故事表達,K2,能按圖片或情境說出與「二至三句復述」相關的完整句。,500134
3,k2,1045,二至三句復述,chinese,口語表達,故事表達,K2,能在簡單對話或故事情境中表達與「二至三句復述」相關的想法。,500135
1,k3,1046,故事開端經過結果,chinese,口語表達,故事表達,K3,能用詞語或短句表達「故事開端經過結果」相關內容。,500136
2,k3,1046,故事開端經過結果,chinese,口語表達,故事表達,K3,能按圖片或情境說出與「故事開端經過結果」相關的完整句。,500137
3,k3,1046,故事開端經過結果,chinese,口語表達,故事表達,K3,能在簡單對話或故事情境中表達與「故事開端經過結果」相關的想法。,500138
1,k3,1047,預測結局,chinese,口語表達,故事表達,K3,能用詞語或短句表達「預測結局」相關內容。,500139
2,k3,1047,預測結局,chinese,口語表達,故事表達,K3,能按圖片或情境說出與「預測結局」相關的完整句。,500140
3,k3,1047,預測結局,chinese,口語表達,故事表達,K3,能在簡單對話或故事情境中表達與「預測結局」相關的想法。,500141
1,k3,1048,角色感受,chinese,口語表達,故事表達,K3,能用詞語或短句表達「角色感受」相關內容。,500142
2,k3,1048,角色感受,chinese,口語表達,故事表達,K3,能按圖片或情境說出與「角色感受」相關的完整句。,500143
3,k3,1048,角色感受,chinese,口語表達,故事表達,K3,能在簡單對話或故事情境中表達與「角色感受」相關的想法。,500144
1,k1,1049,是非問答,chinese,口語表達,問答互動,K1,能用詞語或短句表達「是非問答」相關內容。,500145
2,k1,1049,是非問答,chinese,口語表達,問答互動,K1,能按圖片或情境說出與「是非問答」相關的完整句。,500146
3,k1,1049,是非問答,chinese,口語表達,問答互動,K1,能在簡單對話或故事情境中表達與「是非問答」相關的想法。,500147
1,k1,1050,誰/甚麼問答,chinese,口語表達,問答互動,K1,能用詞語或短句表達「誰/甚麼問答」相關內容。,500148
2,k1,1050,誰/甚麼問答,chinese,口語表達,問答互動,K1,能按圖片或情境說出與「誰/甚麼問答」相關的完整句。,500149
3,k1,1050,誰/甚麼問答,chinese,口語表達,問答互動,K1,能在簡單對話或故事情境中表達與「誰/甚麼問答」相關的想法。,500150
1,k2,1051,哪裡/幾多問答,chinese,口語表達,問答互動,K2,能用詞語或短句表達「哪裡/幾多問答」相關內容。,500151
2,k2,1051,哪裡/幾多問答,chinese,口語表達,問答互動,K2,能按圖片或情境說出與「哪裡/幾多問答」相關的完整句。,500152
3,k2,1051,哪裡/幾多問答,chinese,口語表達,問答互動,K2,能在簡單對話或故事情境中表達與「哪裡/幾多問答」相關的想法。,500153
1,k2,1052,何時問答,chinese,口語表達,問答互動,K2,能用詞語或短句表達「何時問答」相關內容。,500154
2,k2,1052,何時問答,chinese,口語表達,問答互動,K2,能按圖片或情境說出與「何時問答」相關的完整句。,500155
3,k2,1052,何時問答,chinese,口語表達,問答互動,K2,能在簡單對話或故事情境中表達與「何時問答」相關的想法。,500156
1,k3,1053,為甚麼問答,chinese,口語表達,問答互動,K3,能用詞語或短句表達「為甚麼問答」相關內容。,500157
2,k3,1053,為甚麼問答,chinese,口語表達,問答互動,K3,能按圖片或情境說出與「為甚麼問答」相關的完整句。,500158
3,k3,1053,為甚麼問答,chinese,口語表達,問答互動,K3,能在簡單對話或故事情境中表達與「為甚麼問答」相關的想法。,500159
1,k3,1054,怎樣問答,chinese,口語表達,問答互動,K3,能用詞語或短句表達「怎樣問答」相關內容。,500160
2,k3,1054,怎樣問答,chinese,口語表達,問答互動,K3,能按圖片或情境說出與「怎樣問答」相關的完整句。,500161
3,k3,1054,怎樣問答,chinese,口語表達,問答互動,K3,能在簡單對話或故事情境中表達與「怎樣問答」相關的想法。,500162
1,k3,1055,輪流對話,chinese,口語表達,問答互動,K3,能用詞語或短句表達「輪流對話」相關內容。,500163
2,k3,1055,輪流對話,chinese,口語表達,問答互動,K3,能按圖片或情境說出與「輪流對話」相關的完整句。,500164
3,k3,1055,輪流對話,chinese,口語表達,問答互動,K3,能在簡單對話或故事情境中表達與「輪流對話」相關的想法。,500165
1,k1,1056,橫豎撇捺點,chinese,識字與字形,基本筆畫,K1,能辨認或配對「橫豎撇捺點」相關字形、筆畫或部件。,500166
2,k1,1056,橫豎撇捺點,chinese,識字與字形,基本筆畫,K1,能分辨、補全或選出與「橫豎撇捺點」相關的正確字形。,500167
3,k1,1056,橫豎撇捺點,chinese,識字與字形,基本筆畫,K1,能在詞語或短句中辨識並運用「橫豎撇捺點」相關漢字。,500168
1,k1,1057,筆畫配對,chinese,識字與字形,基本筆畫,K1,能辨認或配對「筆畫配對」相關字形、筆畫或部件。,500169
2,k1,1057,筆畫配對,chinese,識字與字形,基本筆畫,K1,能分辨、補全或選出與「筆畫配對」相關的正確字形。,500170
3,k1,1057,筆畫配對,chinese,識字與字形,基本筆畫,K1,能在詞語或短句中辨識並運用「筆畫配對」相關漢字。,500171
1,k2,1058,提鉤折,chinese,識字與字形,基本筆畫,K2,能辨認或配對「提鉤折」相關字形、筆畫或部件。,500172
2,k2,1058,提鉤折,chinese,識字與字形,基本筆畫,K2,能分辨、補全或選出與「提鉤折」相關的正確字形。,500173
3,k2,1058,提鉤折,chinese,識字與字形,基本筆畫,K2,能在詞語或短句中辨識並運用「提鉤折」相關漢字。,500174
1,k2,1059,筆畫數辨識,chinese,識字與字形,基本筆畫,K2,能辨認或配對「筆畫數辨識」相關字形、筆畫或部件。,500175
2,k2,1059,筆畫數辨識,chinese,識字與字形,基本筆畫,K2,能分辨、補全或選出與「筆畫數辨識」相關的正確字形。,500176
3,k2,1059,筆畫數辨識,chinese,識字與字形,基本筆畫,K2,能在詞語或短句中辨識並運用「筆畫數辨識」相關漢字。,500177
1,k3,1060,筆順判斷,chinese,識字與字形,基本筆畫,K3,能辨認或配對「筆順判斷」相關字形、筆畫或部件。,500178
2,k3,1060,筆順判斷,chinese,識字與字形,基本筆畫,K3,能分辨、補全或選出與「筆順判斷」相關的正確字形。,500179
3,k3,1060,筆順判斷,chinese,識字與字形,基本筆畫,K3,能在詞語或短句中辨識並運用「筆順判斷」相關漢字。,500180
1,k3,1061,筆畫組合成字,chinese,識字與字形,基本筆畫,K3,能辨認或配對「筆畫組合成字」相關字形、筆畫或部件。,500181
2,k3,1061,筆畫組合成字,chinese,識字與字形,基本筆畫,K3,能分辨、補全或選出與「筆畫組合成字」相關的正確字形。,500182
3,k3,1061,筆畫組合成字,chinese,識字與字形,基本筆畫,K3,能在詞語或短句中辨識並運用「筆畫組合成字」相關漢字。,500183
1,k1,1062,相同字配對,chinese,識字與字形,字形辨識,K1,能辨認或配對「相同字配對」相關字形、筆畫或部件。,500184
2,k1,1062,相同字配對,chinese,識字與字形,字形辨識,K1,能分辨、補全或選出與「相同字配對」相關的正確字形。,500185
3,k1,1062,相同字配對,chinese,識字與字形,字形辨識,K1,能在詞語或短句中辨識並運用「相同字配對」相關漢字。,500186
1,k1,1063,找出指定字,chinese,識字與字形,字形辨識,K1,能辨認或配對「找出指定字」相關字形、筆畫或部件。,500187
2,k1,1063,找出指定字,chinese,識字與字形,字形辨識,K1,能分辨、補全或選出與「找出指定字」相關的正確字形。,500188
3,k1,1063,找出指定字,chinese,識字與字形,字形辨識,K1,能在詞語或短句中辨識並運用「找出指定字」相關漢字。,500189
1,k2,1064,相近字分辨,chinese,識字與字形,字形辨識,K2,能辨認或配對「相近字分辨」相關字形、筆畫或部件。,500190
2,k2,1064,相近字分辨,chinese,識字與字形,字形辨識,K2,能分辨、補全或選出與「相近字分辨」相關的正確字形。,500191
3,k2,1064,相近字分辨,chinese,識字與字形,字形辨識,K2,能在詞語或短句中辨識並運用「相近字分辨」相關漢字。,500192
1,k2,1065,缺少部件,chinese,識字與字形,字形辨識,K2,能辨認或配對「缺少部件」相關字形、筆畫或部件。,500193
2,k2,1065,缺少部件,chinese,識字與字形,字形辨識,K2,能分辨、補全或選出與「缺少部件」相關的正確字形。,500194
3,k2,1065,缺少部件,chinese,識字與字形,字形辨識,K2,能在詞語或短句中辨識並運用「缺少部件」相關漢字。,500195
1,k3,1066,字形結構辨識,chinese,識字與字形,字形辨識,K3,能辨認或配對「字形結構辨識」相關字形、筆畫或部件。,500196
2,k3,1066,字形結構辨識,chinese,識字與字形,字形辨識,K3,能分辨、補全或選出與「字形結構辨識」相關的正確字形。,500197
3,k3,1066,字形結構辨識,chinese,識字與字形,字形辨識,K3,能在詞語或短句中辨識並運用「字形結構辨識」相關漢字。,500198
1,k3,1067,錯別字辨識,chinese,識字與字形,字形辨識,K3,能辨認或配對「錯別字辨識」相關字形、筆畫或部件。,500199
2,k3,1067,錯別字辨識,chinese,識字與字形,字形辨識,K3,能分辨、補全或選出與「錯別字辨識」相關的正確字形。,500200
3,k3,1067,錯別字辨識,chinese,識字與字形,字形辨識,K3,能在詞語或短句中辨識並運用「錯別字辨識」相關漢字。,500201
1,k1,1068,自己名字,chinese,識字與字形,常用字認讀,K1,能辨認或配對「自己名字」相關字形、筆畫或部件。,500202
2,k1,1068,自己名字,chinese,識字與字形,常用字認讀,K1,能分辨、補全或選出與「自己名字」相關的正確字形。,500203
3,k1,1068,自己名字,chinese,識字與字形,常用字認讀,K1,能在詞語或短句中辨識並運用「自己名字」相關漢字。,500204
1,k1,1069,家庭稱謂字,chinese,識字與字形,常用字認讀,K1,能辨認或配對「家庭稱謂字」相關字形、筆畫或部件。,500205
2,k1,1069,家庭稱謂字,chinese,識字與字形,常用字認讀,K1,能分辨、補全或選出與「家庭稱謂字」相關的正確字形。,500206
3,k1,1069,家庭稱謂字,chinese,識字與字形,常用字認讀,K1,能在詞語或短句中辨識並運用「家庭稱謂字」相關漢字。,500207
1,k1,1070,身體部位字,chinese,識字與字形,常用字認讀,K1,能辨認或配對「身體部位字」相關字形、筆畫或部件。,500208
2,k1,1070,身體部位字,chinese,識字與字形,常用字認讀,K1,能分辨、補全或選出與「身體部位字」相關的正確字形。,500209
3,k1,1070,身體部位字,chinese,識字與字形,常用字認讀,K1,能在詞語或短句中辨識並運用「身體部位字」相關漢字。,500210
1,k2,1071,動物名稱字,chinese,識字與字形,常用字認讀,K2,能辨認或配對「動物名稱字」相關字形、筆畫或部件。,500211
2,k2,1071,動物名稱字,chinese,識字與字形,常用字認讀,K2,能分辨、補全或選出與「動物名稱字」相關的正確字形。,500212
3,k2,1071,動物名稱字,chinese,識字與字形,常用字認讀,K2,能在詞語或短句中辨識並運用「動物名稱字」相關漢字。,500213
1,k2,1072,食物名稱字,chinese,識字與字形,常用字認讀,K2,能辨認或配對「食物名稱字」相關字形、筆畫或部件。,500214
2,k2,1072,食物名稱字,chinese,識字與字形,常用字認讀,K2,能分辨、補全或選出與「食物名稱字」相關的正確字形。,500215
3,k2,1072,食物名稱字,chinese,識字與字形,常用字認讀,K2,能在詞語或短句中辨識並運用「食物名稱字」相關漢字。,500216
1,k2,1073,學校用品字,chinese,識字與字形,常用字認讀,K2,能辨認或配對「學校用品字」相關字形、筆畫或部件。,500217
2,k2,1073,學校用品字,chinese,識字與字形,常用字認讀,K2,能分辨、補全或選出與「學校用品字」相關的正確字形。,500218
3,k2,1073,學校用品字,chinese,識字與字形,常用字認讀,K2,能在詞語或短句中辨識並運用「學校用品字」相關漢字。,500219
1,k3,1074,生活常用字,chinese,識字與字形,常用字認讀,K3,能辨認或配對「生活常用字」相關字形、筆畫或部件。,500220
2,k3,1074,生活常用字,chinese,識字與字形,常用字認讀,K3,能分辨、補全或選出與「生活常用字」相關的正確字形。,500221
3,k3,1074,生活常用字,chinese,識字與字形,常用字認讀,K3,能在詞語或短句中辨識並運用「生活常用字」相關漢字。,500222
1,k3,1075,時間天氣字,chinese,識字與字形,常用字認讀,K3,能辨認或配對「時間天氣字」相關字形、筆畫或部件。,500223
2,k3,1075,時間天氣字,chinese,識字與字形,常用字認讀,K3,能分辨、補全或選出與「時間天氣字」相關的正確字形。,500224
3,k3,1075,時間天氣字,chinese,識字與字形,常用字認讀,K3,能在詞語或短句中辨識並運用「時間天氣字」相關漢字。,500225
1,k3,1076,地方名稱字,chinese,識字與字形,常用字認讀,K3,能辨認或配對「地方名稱字」相關字形、筆畫或部件。,500226
2,k3,1076,地方名稱字,chinese,識字與字形,常用字認讀,K3,能分辨、補全或選出與「地方名稱字」相關的正確字形。,500227
3,k3,1076,地方名稱字,chinese,識字與字形,常用字認讀,K3,能在詞語或短句中辨識並運用「地方名稱字」相關漢字。,500228
1,k1,1077,常見象形字,chinese,識字與字形,部件與結構,K1,能辨認或配對「常見象形字」相關字形、筆畫或部件。,500229
2,k1,1077,常見象形字,chinese,識字與字形,部件與結構,K1,能分辨、補全或選出與「常見象形字」相關的正確字形。,500230
3,k1,1077,常見象形字,chinese,識字與字形,部件與結構,K1,能在詞語或短句中辨識並運用「常見象形字」相關漢字。,500231
1,k1,1078,單一部件認識,chinese,識字與字形,部件與結構,K1,能辨認或配對「單一部件認識」相關字形、筆畫或部件。,500232
2,k1,1078,單一部件認識,chinese,識字與字形,部件與結構,K1,能分辨、補全或選出與「單一部件認識」相關的正確字形。,500233
3,k1,1078,單一部件認識,chinese,識字與字形,部件與結構,K1,能在詞語或短句中辨識並運用「單一部件認識」相關漢字。,500234
1,k2,1079,左右結構,chinese,識字與字形,部件與結構,K2,能辨認或配對「左右結構」相關字形、筆畫或部件。,500235
2,k2,1079,左右結構,chinese,識字與字形,部件與結構,K2,能分辨、補全或選出與「左右結構」相關的正確字形。,500236
3,k2,1079,左右結構,chinese,識字與字形,部件與結構,K2,能在詞語或短句中辨識並運用「左右結構」相關漢字。,500237
1,k2,1080,上下結構,chinese,識字與字形,部件與結構,K2,能辨認或配對「上下結構」相關字形、筆畫或部件。,500238
2,k2,1080,上下結構,chinese,識字與字形,部件與結構,K2,能分辨、補全或選出與「上下結構」相關的正確字形。,500239
3,k2,1080,上下結構,chinese,識字與字形,部件與結構,K2,能在詞語或短句中辨識並運用「上下結構」相關漢字。,500240
1,k2,1081,常見部首,chinese,識字與字形,部件與結構,K2,能辨認或配對「常見部首」相關字形、筆畫或部件。,500241
2,k2,1081,常見部首,chinese,識字與字形,部件與結構,K2,能分辨、補全或選出與「常見部首」相關的正確字形。,500242
3,k2,1081,常見部首,chinese,識字與字形,部件與結構,K2,能在詞語或短句中辨識並運用「常見部首」相關漢字。,500243
1,k3,1082,部件組合,chinese,識字與字形,部件與結構,K3,能辨認或配對「部件組合」相關字形、筆畫或部件。,500244
2,k3,1082,部件組合,chinese,識字與字形,部件與結構,K3,能分辨、補全或選出與「部件組合」相關的正確字形。,500245
3,k3,1082,部件組合,chinese,識字與字形,部件與結構,K3,能在詞語或短句中辨識並運用「部件組合」相關漢字。,500246
1,k3,1083,部首表義,chinese,識字與字形,部件與結構,K3,能辨認或配對「部首表義」相關字形、筆畫或部件。,500247
2,k3,1083,部首表義,chinese,識字與字形,部件與結構,K3,能分辨、補全或選出與「部首表義」相關的正確字形。,500248
3,k3,1083,部首表義,chinese,識字與字形,部件與結構,K3,能在詞語或短句中辨識並運用「部首表義」相關漢字。,500249
1,k3,1084,包圍結構,chinese,識字與字形,部件與結構,K3,能辨認或配對「包圍結構」相關字形、筆畫或部件。,500250
2,k3,1084,包圍結構,chinese,識字與字形,部件與結構,K3,能分辨、補全或選出與「包圍結構」相關的正確字形。,500251
3,k3,1084,包圍結構,chinese,識字與字形,部件與結構,K3,能在詞語或短句中辨識並運用「包圍結構」相關漢字。,500252
1,k1,1085,常見標誌配對,chinese,識字與字形,生活標誌與符號,K1,能辨認或配對「常見標誌配對」相關字形、筆畫或部件。,500253
2,k1,1085,常見標誌配對,chinese,識字與字形,生活標誌與符號,K1,能分辨、補全或選出與「常見標誌配對」相關的正確字形。,500254
3,k1,1085,常見標誌配對,chinese,識字與字形,生活標誌與符號,K1,能在詞語或短句中辨識並運用「常見標誌配對」相關漢字。,500255
1,k2,1086,安全標誌,chinese,識字與字形,生活標誌與符號,K2,能辨認或配對「安全標誌」相關字形、筆畫或部件。,500256
2,k2,1086,安全標誌,chinese,識字與字形,生活標誌與符號,K2,能分辨、補全或選出與「安全標誌」相關的正確字形。,500257
3,k2,1086,安全標誌,chinese,識字與字形,生活標誌與符號,K2,能在詞語或短句中辨識並運用「安全標誌」相關漢字。,500258
1,k2,1087,方向標誌,chinese,識字與字形,生活標誌與符號,K2,能辨認或配對「方向標誌」相關字形、筆畫或部件。,500259
2,k2,1087,方向標誌,chinese,識字與字形,生活標誌與符號,K2,能分辨、補全或選出與「方向標誌」相關的正確字形。,500260
3,k2,1087,方向標誌,chinese,識字與字形,生活標誌與符號,K2,能在詞語或短句中辨識並運用「方向標誌」相關漢字。,500261
1,k3,1088,場所標誌,chinese,識字與字形,生活標誌與符號,K3,能辨認或配對「場所標誌」相關字形、筆畫或部件。,500262
2,k3,1088,場所標誌,chinese,識字與字形,生活標誌與符號,K3,能分辨、補全或選出與「場所標誌」相關的正確字形。,500263
3,k3,1088,場所標誌,chinese,識字與字形,生活標誌與符號,K3,能在詞語或短句中辨識並運用「場所標誌」相關漢字。,500264
1,k3,1089,提示語理解,chinese,識字與字形,生活標誌與符號,K3,能辨認或配對「提示語理解」相關字形、筆畫或部件。,500265
2,k3,1089,提示語理解,chinese,識字與字形,生活標誌與符號,K3,能分辨、補全或選出與「提示語理解」相關的正確字形。,500266
3,k3,1089,提示語理解,chinese,識字與字形,生活標誌與符號,K3,能在詞語或短句中辨識並運用「提示語理解」相關漢字。,500267
1,k1,1090,動物詞,chinese,詞語理解與運用,生活詞彙,K1,能理解並配對「動物詞」相關詞語和圖片。,500268
2,k1,1090,動物詞,chinese,詞語理解與運用,生活詞彙,K1,能把「動物詞」相關詞語作分類、配搭或選擇。,500269
3,k1,1090,動物詞,chinese,詞語理解與運用,生活詞彙,K1,能在短句或生活情境中正確運用「動物詞」相關詞語。,500270
1,k1,1091,食物詞,chinese,詞語理解與運用,生活詞彙,K1,能理解並配對「食物詞」相關詞語和圖片。,500271
2,k1,1091,食物詞,chinese,詞語理解與運用,生活詞彙,K1,能把「食物詞」相關詞語作分類、配搭或選擇。,500272
3,k1,1091,食物詞,chinese,詞語理解與運用,生活詞彙,K1,能在短句或生活情境中正確運用「食物詞」相關詞語。,500273
1,k1,1092,身體詞,chinese,詞語理解與運用,生活詞彙,K1,能理解並配對「身體詞」相關詞語和圖片。,500274
2,k1,1092,身體詞,chinese,詞語理解與運用,生活詞彙,K1,能把「身體詞」相關詞語作分類、配搭或選擇。,500275
3,k1,1092,身體詞,chinese,詞語理解與運用,生活詞彙,K1,能在短句或生活情境中正確運用「身體詞」相關詞語。,500276
1,k2,1093,衣物詞,chinese,詞語理解與運用,生活詞彙,K2,能理解並配對「衣物詞」相關詞語和圖片。,500277
2,k2,1093,衣物詞,chinese,詞語理解與運用,生活詞彙,K2,能把「衣物詞」相關詞語作分類、配搭或選擇。,500278
3,k2,1093,衣物詞,chinese,詞語理解與運用,生活詞彙,K2,能在短句或生活情境中正確運用「衣物詞」相關詞語。,500279
1,k2,1094,交通工具詞,chinese,詞語理解與運用,生活詞彙,K2,能理解並配對「交通工具詞」相關詞語和圖片。,500280
2,k2,1094,交通工具詞,chinese,詞語理解與運用,生活詞彙,K2,能把「交通工具詞」相關詞語作分類、配搭或選擇。,500281
3,k2,1094,交通工具詞,chinese,詞語理解與運用,生活詞彙,K2,能在短句或生活情境中正確運用「交通工具詞」相關詞語。,500282
1,k2,1095,學校用品詞,chinese,詞語理解與運用,生活詞彙,K2,能理解並配對「學校用品詞」相關詞語和圖片。,500283
2,k2,1095,學校用品詞,chinese,詞語理解與運用,生活詞彙,K2,能把「學校用品詞」相關詞語作分類、配搭或選擇。,500284
3,k2,1095,學校用品詞,chinese,詞語理解與運用,生活詞彙,K2,能在短句或生活情境中正確運用「學校用品詞」相關詞語。,500285
1,k3,1096,天氣詞,chinese,詞語理解與運用,生活詞彙,K3,能理解並配對「天氣詞」相關詞語和圖片。,500286
2,k3,1096,天氣詞,chinese,詞語理解與運用,生活詞彙,K3,能把「天氣詞」相關詞語作分類、配搭或選擇。,500287
3,k3,1096,天氣詞,chinese,詞語理解與運用,生活詞彙,K3,能在短句或生活情境中正確運用「天氣詞」相關詞語。,500288
1,k3,1097,節日詞,chinese,詞語理解與運用,生活詞彙,K3,能理解並配對「節日詞」相關詞語和圖片。,500289
2,k3,1097,節日詞,chinese,詞語理解與運用,生活詞彙,K3,能把「節日詞」相關詞語作分類、配搭或選擇。,500290
3,k3,1097,節日詞,chinese,詞語理解與運用,生活詞彙,K3,能在短句或生活情境中正確運用「節日詞」相關詞語。,500291
1,k3,1098,社區場所詞,chinese,詞語理解與運用,生活詞彙,K3,能理解並配對「社區場所詞」相關詞語和圖片。,500292
2,k3,1098,社區場所詞,chinese,詞語理解與運用,生活詞彙,K3,能把「社區場所詞」相關詞語作分類、配搭或選擇。,500293
3,k3,1098,社區場所詞,chinese,詞語理解與運用,生活詞彙,K3,能在短句或生活情境中正確運用「社區場所詞」相關詞語。,500294
1,k1,1099,同類物件,chinese,詞語理解與運用,詞義分類,K1,能理解並配對「同類物件」相關詞語和圖片。,500295
2,k1,1099,同類物件,chinese,詞語理解與運用,詞義分類,K1,能把「同類物件」相關詞語作分類、配搭或選擇。,500296
3,k1,1099,同類物件,chinese,詞語理解與運用,詞義分類,K1,能在短句或生活情境中正確運用「同類物件」相關詞語。,500297
1,k1,1100,顏色詞,chinese,詞語理解與運用,詞義分類,K1,能理解並配對「顏色詞」相關詞語和圖片。,500298
2,k1,1100,顏色詞,chinese,詞語理解與運用,詞義分類,K1,能把「顏色詞」相關詞語作分類、配搭或選擇。,500299
3,k1,1100,顏色詞,chinese,詞語理解與運用,詞義分類,K1,能在短句或生活情境中正確運用「顏色詞」相關詞語。,500300
1,k2,1101,動作詞,chinese,詞語理解與運用,詞義分類,K2,能理解並配對「動作詞」相關詞語和圖片。,500301
2,k2,1101,動作詞,chinese,詞語理解與運用,詞義分類,K2,能把「動作詞」相關詞語作分類、配搭或選擇。,500302
3,k2,1101,動作詞,chinese,詞語理解與運用,詞義分類,K2,能在短句或生活情境中正確運用「動作詞」相關詞語。,500303
1,k2,1102,位置詞,chinese,詞語理解與運用,詞義分類,K2,能理解並配對「位置詞」相關詞語和圖片。,500304
2,k2,1102,位置詞,chinese,詞語理解與運用,詞義分類,K2,能把「位置詞」相關詞語作分類、配搭或選擇。,500305
3,k2,1102,位置詞,chinese,詞語理解與運用,詞義分類,K2,能在短句或生活情境中正確運用「位置詞」相關詞語。,500306
1,k2,1103,反義詞,chinese,詞語理解與運用,詞義分類,K2,能理解並配對「反義詞」相關詞語和圖片。,500307
2,k2,1103,反義詞,chinese,詞語理解與運用,詞義分類,K2,能把「反義詞」相關詞語作分類、配搭或選擇。,500308
3,k2,1103,反義詞,chinese,詞語理解與運用,詞義分類,K2,能在短句或生活情境中正確運用「反義詞」相關詞語。,500309
1,k3,1104,類別歸納,chinese,詞語理解與運用,詞義分類,K3,能理解並配對「類別歸納」相關詞語和圖片。,500310
2,k3,1104,類別歸納,chinese,詞語理解與運用,詞義分類,K3,能把「類別歸納」相關詞語作分類、配搭或選擇。,500311
3,k3,1104,類別歸納,chinese,詞語理解與運用,詞義分類,K3,能在短句或生活情境中正確運用「類別歸納」相關詞語。,500312
1,k3,1105,詞語找不同,chinese,詞語理解與運用,詞義分類,K3,能理解並配對「詞語找不同」相關詞語和圖片。,500313
2,k3,1105,詞語找不同,chinese,詞語理解與運用,詞義分類,K3,能把「詞語找不同」相關詞語作分類、配搭或選擇。,500314
3,k3,1105,詞語找不同,chinese,詞語理解與運用,詞義分類,K3,能在短句或生活情境中正確運用「詞語找不同」相關詞語。,500315
1,k3,1106,近義詞初步,chinese,詞語理解與運用,詞義分類,K3,能理解並配對「近義詞初步」相關詞語和圖片。,500316
2,k3,1106,近義詞初步,chinese,詞語理解與運用,詞義分類,K3,能把「近義詞初步」相關詞語作分類、配搭或選擇。,500317
3,k3,1106,近義詞初步,chinese,詞語理解與運用,詞義分類,K3,能在短句或生活情境中正確運用「近義詞初步」相關詞語。,500318
1,k1,1107,個,chinese,詞語理解與運用,量詞,K1,能理解並配對「個」相關詞語和圖片。,500319
2,k1,1107,個,chinese,詞語理解與運用,量詞,K1,能把「個」相關詞語作分類、配搭或選擇。,500320
3,k1,1107,個,chinese,詞語理解與運用,量詞,K1,能在短句或生活情境中正確運用「個」相關詞語。,500321
1,k1,1108,隻,chinese,詞語理解與運用,量詞,K1,能理解並配對「隻」相關詞語和圖片。,500322
2,k1,1108,隻,chinese,詞語理解與運用,量詞,K1,能把「隻」相關詞語作分類、配搭或選擇。,500323
3,k1,1108,隻,chinese,詞語理解與運用,量詞,K1,能在短句或生活情境中正確運用「隻」相關詞語。,500324
1,k2,1109,條,chinese,詞語理解與運用,量詞,K2,能理解並配對「條」相關詞語和圖片。,500325
2,k2,1109,條,chinese,詞語理解與運用,量詞,K2,能把「條」相關詞語作分類、配搭或選擇。,500326
3,k2,1109,條,chinese,詞語理解與運用,量詞,K2,能在短句或生活情境中正確運用「條」相關詞語。,500327
1,k2,1110,張,chinese,詞語理解與運用,量詞,K2,能理解並配對「張」相關詞語和圖片。,500328
2,k2,1110,張,chinese,詞語理解與運用,量詞,K2,能把「張」相關詞語作分類、配搭或選擇。,500329
3,k2,1110,張,chinese,詞語理解與運用,量詞,K2,能在短句或生活情境中正確運用「張」相關詞語。,500330
1,k2,1111,枝,chinese,詞語理解與運用,量詞,K2,能理解並配對「枝」相關詞語和圖片。,500331
2,k2,1111,枝,chinese,詞語理解與運用,量詞,K2,能把「枝」相關詞語作分類、配搭或選擇。,500332
3,k2,1111,枝,chinese,詞語理解與運用,量詞,K2,能在短句或生活情境中正確運用「枝」相關詞語。,500333
1,k2,1112,本,chinese,詞語理解與運用,量詞,K2,能理解並配對「本」相關詞語和圖片。,500334
2,k2,1112,本,chinese,詞語理解與運用,量詞,K2,能把「本」相關詞語作分類、配搭或選擇。,500335
3,k2,1112,本,chinese,詞語理解與運用,量詞,K2,能在短句或生活情境中正確運用「本」相關詞語。,500336
1,k3,1113,件,chinese,詞語理解與運用,量詞,K3,能理解並配對「件」相關詞語和圖片。,500337
2,k3,1113,件,chinese,詞語理解與運用,量詞,K3,能把「件」相關詞語作分類、配搭或選擇。,500338
3,k3,1113,件,chinese,詞語理解與運用,量詞,K3,能在短句或生活情境中正確運用「件」相關詞語。,500339
1,k3,1114,架,chinese,詞語理解與運用,量詞,K3,能理解並配對「架」相關詞語和圖片。,500340
2,k3,1114,架,chinese,詞語理解與運用,量詞,K3,能把「架」相關詞語作分類、配搭或選擇。,500341
3,k3,1114,架,chinese,詞語理解與運用,量詞,K3,能在短句或生活情境中正確運用「架」相關詞語。,500342
1,k3,1115,朵,chinese,詞語理解與運用,量詞,K3,能理解並配對「朵」相關詞語和圖片。,500343
2,k3,1115,朵,chinese,詞語理解與運用,量詞,K3,能把「朵」相關詞語作分類、配搭或選擇。,500344
3,k3,1115,朵,chinese,詞語理解與運用,量詞,K3,能在短句或生活情境中正確運用「朵」相關詞語。,500345
1,k3,1116,杯,chinese,詞語理解與運用,量詞,K3,能理解並配對「杯」相關詞語和圖片。,500346
2,k3,1116,杯,chinese,詞語理解與運用,量詞,K3,能把「杯」相關詞語作分類、配搭或選擇。,500347
3,k3,1116,杯,chinese,詞語理解與運用,量詞,K3,能在短句或生活情境中正確運用「杯」相關詞語。,500348
1,k3,1117,碗,chinese,詞語理解與運用,量詞,K3,能理解並配對「碗」相關詞語和圖片。,500349
2,k3,1117,碗,chinese,詞語理解與運用,量詞,K3,能把「碗」相關詞語作分類、配搭或選擇。,500350
3,k3,1117,碗,chinese,詞語理解與運用,量詞,K3,能在短句或生活情境中正確運用「碗」相關詞語。,500351
1,k1,1118,名詞配圖,chinese,詞語理解與運用,詞語配搭,K1,能理解並配對「名詞配圖」相關詞語和圖片。,500352
2,k1,1118,名詞配圖,chinese,詞語理解與運用,詞語配搭,K1,能把「名詞配圖」相關詞語作分類、配搭或選擇。,500353
3,k1,1118,名詞配圖,chinese,詞語理解與運用,詞語配搭,K1,能在短句或生活情境中正確運用「名詞配圖」相關詞語。,500354
1,k1,1119,動作配圖,chinese,詞語理解與運用,詞語配搭,K1,能理解並配對「動作配圖」相關詞語和圖片。,500355
2,k1,1119,動作配圖,chinese,詞語理解與運用,詞語配搭,K1,能把「動作配圖」相關詞語作分類、配搭或選擇。,500356
3,k1,1119,動作配圖,chinese,詞語理解與運用,詞語配搭,K1,能在短句或生活情境中正確運用「動作配圖」相關詞語。,500357
1,k2,1120,動詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能理解並配對「動詞配名詞」相關詞語和圖片。,500358
2,k2,1120,動詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能把「動詞配名詞」相關詞語作分類、配搭或選擇。,500359
3,k2,1120,動詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能在短句或生活情境中正確運用「動詞配名詞」相關詞語。,500360
1,k2,1121,形容詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能理解並配對「形容詞配名詞」相關詞語和圖片。,500361
2,k2,1121,形容詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能把「形容詞配名詞」相關詞語作分類、配搭或選擇。,500362
3,k2,1121,形容詞配名詞,chinese,詞語理解與運用,詞語配搭,K2,能在短句或生活情境中正確運用「形容詞配名詞」相關詞語。,500363
1,k3,1122,詞語填空,chinese,詞語理解與運用,詞語配搭,K3,能理解並配對「詞語填空」相關詞語和圖片。,500364
2,k3,1122,詞語填空,chinese,詞語理解與運用,詞語配搭,K3,能把「詞語填空」相關詞語作分類、配搭或選擇。,500365
3,k3,1122,詞語填空,chinese,詞語理解與運用,詞語配搭,K3,能在短句或生活情境中正確運用「詞語填空」相關詞語。,500366
1,k3,1123,合適詞語選擇,chinese,詞語理解與運用,詞語配搭,K3,能理解並配對「合適詞語選擇」相關詞語和圖片。,500367
2,k3,1123,合適詞語選擇,chinese,詞語理解與運用,詞語配搭,K3,能把「合適詞語選擇」相關詞語作分類、配搭或選擇。,500368
3,k3,1123,合適詞語選擇,chinese,詞語理解與運用,詞語配搭,K3,能在短句或生活情境中正確運用「合適詞語選擇」相關詞語。,500369
1,k3,1124,短語配搭,chinese,詞語理解與運用,詞語配搭,K3,能理解並配對「短語配搭」相關詞語和圖片。,500370
2,k3,1124,短語配搭,chinese,詞語理解與運用,詞語配搭,K3,能把「短語配搭」相關詞語作分類、配搭或選擇。,500371
3,k3,1124,短語配搭,chinese,詞語理解與運用,詞語配搭,K3,能在短句或生活情境中正確運用「短語配搭」相關詞語。,500372
1,k1,1125,早上/晚上,chinese,詞語理解與運用,時間與次序詞,K1,能理解並配對「早上/晚上」相關詞語和圖片。,500373
2,k1,1125,早上/晚上,chinese,詞語理解與運用,時間與次序詞,K1,能把「早上/晚上」相關詞語作分類、配搭或選擇。,500374
3,k1,1125,早上/晚上,chinese,詞語理解與運用,時間與次序詞,K1,能在短句或生活情境中正確運用「早上/晚上」相關詞語。,500375
1,k1,1126,今天,chinese,詞語理解與運用,時間與次序詞,K1,能理解並配對「今天」相關詞語和圖片。,500376
2,k1,1126,今天,chinese,詞語理解與運用,時間與次序詞,K1,能把「今天」相關詞語作分類、配搭或選擇。,500377
3,k1,1126,今天,chinese,詞語理解與運用,時間與次序詞,K1,能在短句或生活情境中正確運用「今天」相關詞語。,500378
1,k2,1127,昨天/今天/明天,chinese,詞語理解與運用,時間與次序詞,K2,能理解並配對「昨天/今天/明天」相關詞語和圖片。,500379
2,k2,1127,昨天/今天/明天,chinese,詞語理解與運用,時間與次序詞,K2,能把「昨天/今天/明天」相關詞語作分類、配搭或選擇。,500380
3,k2,1127,昨天/今天/明天,chinese,詞語理解與運用,時間與次序詞,K2,能在短句或生活情境中正確運用「昨天/今天/明天」相關詞語。,500381
1,k2,1128,先/後,chinese,詞語理解與運用,時間與次序詞,K2,能理解並配對「先/後」相關詞語和圖片。,500382
2,k2,1128,先/後,chinese,詞語理解與運用,時間與次序詞,K2,能把「先/後」相關詞語作分類、配搭或選擇。,500383
3,k2,1128,先/後,chinese,詞語理解與運用,時間與次序詞,K2,能在短句或生活情境中正確運用「先/後」相關詞語。,500384
1,k3,1129,首先/然後/最後,chinese,詞語理解與運用,時間與次序詞,K3,能理解並配對「首先/然後/最後」相關詞語和圖片。,500385
2,k3,1129,首先/然後/最後,chinese,詞語理解與運用,時間與次序詞,K3,能把「首先/然後/最後」相關詞語作分類、配搭或選擇。,500386
3,k3,1129,首先/然後/最後,chinese,詞語理解與運用,時間與次序詞,K3,能在短句或生活情境中正確運用「首先/然後/最後」相關詞語。,500387
1,k3,1130,以前/現在/以後,chinese,詞語理解與運用,時間與次序詞,K3,能理解並配對「以前/現在/以後」相關詞語和圖片。,500388
2,k3,1130,以前/現在/以後,chinese,詞語理解與運用,時間與次序詞,K3,能把「以前/現在/以後」相關詞語作分類、配搭或選擇。,500389
3,k3,1130,以前/現在/以後,chinese,詞語理解與運用,時間與次序詞,K3,能在短句或生活情境中正確運用「以前/現在/以後」相關詞語。,500390
1,k1,1131,字詞配圖,chinese,閱讀理解,圖文配對,K1,能閱讀並找出與「字詞配圖」相關的明顯資料。,500391
2,k1,1131,字詞配圖,chinese,閱讀理解,圖文配對,K1,能根據圖文或短文理解與「字詞配圖」相關的內容。,500392
3,k1,1131,字詞配圖,chinese,閱讀理解,圖文配對,K1,能根據短文或故事推斷與「字詞配圖」相關的原因、次序或主旨。,500393
1,k1,1132,短句配圖,chinese,閱讀理解,圖文配對,K1,能閱讀並找出與「短句配圖」相關的明顯資料。,500394
2,k1,1132,短句配圖,chinese,閱讀理解,圖文配對,K1,能根據圖文或短文理解與「短句配圖」相關的內容。,500395
3,k1,1132,短句配圖,chinese,閱讀理解,圖文配對,K1,能根據短文或故事推斷與「短句配圖」相關的原因、次序或主旨。,500396
1,k2,1133,圖文判斷,chinese,閱讀理解,圖文配對,K2,能閱讀並找出與「圖文判斷」相關的明顯資料。,500397
2,k2,1133,圖文判斷,chinese,閱讀理解,圖文配對,K2,能根據圖文或短文理解與「圖文判斷」相關的內容。,500398
3,k2,1133,圖文判斷,chinese,閱讀理解,圖文配對,K2,能根據短文或故事推斷與「圖文判斷」相關的原因、次序或主旨。,500399
1,k2,1134,找出句中物件,chinese,閱讀理解,圖文配對,K2,能閱讀並找出與「找出句中物件」相關的明顯資料。,500400
2,k2,1134,找出句中物件,chinese,閱讀理解,圖文配對,K2,能根據圖文或短文理解與「找出句中物件」相關的內容。,500401
3,k2,1134,找出句中物件,chinese,閱讀理解,圖文配對,K2,能根據短文或故事推斷與「找出句中物件」相關的原因、次序或主旨。,500402
1,k3,1135,多圖配句,chinese,閱讀理解,圖文配對,K3,能閱讀並找出與「多圖配句」相關的明顯資料。,500403
2,k3,1135,多圖配句,chinese,閱讀理解,圖文配對,K3,能根據圖文或短文理解與「多圖配句」相關的內容。,500404
3,k3,1135,多圖配句,chinese,閱讀理解,圖文配對,K3,能根據短文或故事推斷與「多圖配句」相關的原因、次序或主旨。,500405
1,k3,1136,圖文推論,chinese,閱讀理解,圖文配對,K3,能閱讀並找出與「圖文推論」相關的明顯資料。,500406
2,k3,1136,圖文推論,chinese,閱讀理解,圖文配對,K3,能根據圖文或短文理解與「圖文推論」相關的內容。,500407
3,k3,1136,圖文推論,chinese,閱讀理解,圖文配對,K3,能根據短文或故事推斷與「圖文推論」相關的原因、次序或主旨。,500408
1,k1,1137,誰做甚麼,chinese,閱讀理解,句子理解,K1,能閱讀並找出與「誰做甚麼」相關的明顯資料。,500409
2,k1,1137,誰做甚麼,chinese,閱讀理解,句子理解,K1,能根據圖文或短文理解與「誰做甚麼」相關的內容。,500410
3,k1,1137,誰做甚麼,chinese,閱讀理解,句子理解,K1,能根據短文或故事推斷與「誰做甚麼」相關的原因、次序或主旨。,500411
1,k1,1138,物件與動作,chinese,閱讀理解,句子理解,K1,能閱讀並找出與「物件與動作」相關的明顯資料。,500412
2,k1,1138,物件與動作,chinese,閱讀理解,句子理解,K1,能根據圖文或短文理解與「物件與動作」相關的內容。,500413
3,k1,1138,物件與動作,chinese,閱讀理解,句子理解,K1,能根據短文或故事推斷與「物件與動作」相關的原因、次序或主旨。,500414
1,k2,1139,地點理解,chinese,閱讀理解,句子理解,K2,能閱讀並找出與「地點理解」相關的明顯資料。,500415
2,k2,1139,地點理解,chinese,閱讀理解,句子理解,K2,能根據圖文或短文理解與「地點理解」相關的內容。,500416
3,k2,1139,地點理解,chinese,閱讀理解,句子理解,K2,能根據短文或故事推斷與「地點理解」相關的原因、次序或主旨。,500417
1,k2,1140,時間理解,chinese,閱讀理解,句子理解,K2,能閱讀並找出與「時間理解」相關的明顯資料。,500418
2,k2,1140,時間理解,chinese,閱讀理解,句子理解,K2,能根據圖文或短文理解與「時間理解」相關的內容。,500419
3,k2,1140,時間理解,chinese,閱讀理解,句子理解,K2,能根據短文或故事推斷與「時間理解」相關的原因、次序或主旨。,500420
1,k2,1141,數量理解,chinese,閱讀理解,句子理解,K2,能閱讀並找出與「數量理解」相關的明顯資料。,500421
2,k2,1141,數量理解,chinese,閱讀理解,句子理解,K2,能根據圖文或短文理解與「數量理解」相關的內容。,500422
3,k2,1141,數量理解,chinese,閱讀理解,句子理解,K2,能根據短文或故事推斷與「數量理解」相關的原因、次序或主旨。,500423
1,k3,1142,原因理解,chinese,閱讀理解,句子理解,K3,能閱讀並找出與「原因理解」相關的明顯資料。,500424
2,k3,1142,原因理解,chinese,閱讀理解,句子理解,K3,能根據圖文或短文理解與「原因理解」相關的內容。,500425
3,k3,1142,原因理解,chinese,閱讀理解,句子理解,K3,能根據短文或故事推斷與「原因理解」相關的原因、次序或主旨。,500426
1,k3,1143,感受理解,chinese,閱讀理解,句子理解,K3,能閱讀並找出與「感受理解」相關的明顯資料。,500427
2,k3,1143,感受理解,chinese,閱讀理解,句子理解,K3,能根據圖文或短文理解與「感受理解」相關的內容。,500428
3,k3,1143,感受理解,chinese,閱讀理解,句子理解,K3,能根據短文或故事推斷與「感受理解」相關的原因、次序或主旨。,500429
1,k3,1144,句意推論,chinese,閱讀理解,句子理解,K3,能閱讀並找出與「句意推論」相關的明顯資料。,500430
2,k3,1144,句意推論,chinese,閱讀理解,句子理解,K3,能根據圖文或短文理解與「句意推論」相關的內容。,500431
3,k3,1144,句意推論,chinese,閱讀理解,句子理解,K3,能根據短文或故事推斷與「句意推論」相關的原因、次序或主旨。,500432
1,k1,1145,人物辨識,chinese,閱讀理解,故事理解,K1,能閱讀並找出與「人物辨識」相關的明顯資料。,500433
2,k1,1145,人物辨識,chinese,閱讀理解,故事理解,K1,能根據圖文或短文理解與「人物辨識」相關的內容。,500434
3,k1,1145,人物辨識,chinese,閱讀理解,故事理解,K1,能根據短文或故事推斷與「人物辨識」相關的原因、次序或主旨。,500435
1,k1,1146,事件辨識,chinese,閱讀理解,故事理解,K1,能閱讀並找出與「事件辨識」相關的明顯資料。,500436
2,k1,1146,事件辨識,chinese,閱讀理解,故事理解,K1,能根據圖文或短文理解與「事件辨識」相關的內容。,500437
3,k1,1146,事件辨識,chinese,閱讀理解,故事理解,K1,能根據短文或故事推斷與「事件辨識」相關的原因、次序或主旨。,500438
1,k2,1147,故事排序,chinese,閱讀理解,故事理解,K2,能閱讀並找出與「故事排序」相關的明顯資料。,500439
2,k2,1147,故事排序,chinese,閱讀理解,故事理解,K2,能根據圖文或短文理解與「故事排序」相關的內容。,500440
3,k2,1147,故事排序,chinese,閱讀理解,故事理解,K2,能根據短文或故事推斷與「故事排序」相關的原因、次序或主旨。,500441
1,k2,1148,地點辨識,chinese,閱讀理解,故事理解,K2,能閱讀並找出與「地點辨識」相關的明顯資料。,500442
2,k2,1148,地點辨識,chinese,閱讀理解,故事理解,K2,能根據圖文或短文理解與「地點辨識」相關的內容。,500443
3,k2,1148,地點辨識,chinese,閱讀理解,故事理解,K2,能根據短文或故事推斷與「地點辨識」相關的原因、次序或主旨。,500444
1,k2,1149,角色行動,chinese,閱讀理解,故事理解,K2,能閱讀並找出與「角色行動」相關的明顯資料。,500445
2,k2,1149,角色行動,chinese,閱讀理解,故事理解,K2,能根據圖文或短文理解與「角色行動」相關的內容。,500446
3,k2,1149,角色行動,chinese,閱讀理解,故事理解,K2,能根據短文或故事推斷與「角色行動」相關的原因、次序或主旨。,500447
1,k3,1150,起因經過結果,chinese,閱讀理解,故事理解,K3,能閱讀並找出與「起因經過結果」相關的明顯資料。,500448
2,k3,1150,起因經過結果,chinese,閱讀理解,故事理解,K3,能根據圖文或短文理解與「起因經過結果」相關的內容。,500449
3,k3,1150,起因經過結果,chinese,閱讀理解,故事理解,K3,能根據短文或故事推斷與「起因經過結果」相關的原因、次序或主旨。,500450
1,k3,1151,主旨理解,chinese,閱讀理解,故事理解,K3,能閱讀並找出與「主旨理解」相關的明顯資料。,500451
2,k3,1151,主旨理解,chinese,閱讀理解,故事理解,K3,能根據圖文或短文理解與「主旨理解」相關的內容。,500452
3,k3,1151,主旨理解,chinese,閱讀理解,故事理解,K3,能根據短文或故事推斷與「主旨理解」相關的原因、次序或主旨。,500453
1,k3,1152,預測發展,chinese,閱讀理解,故事理解,K3,能閱讀並找出與「預測發展」相關的明顯資料。,500454
2,k3,1152,預測發展,chinese,閱讀理解,故事理解,K3,能根據圖文或短文理解與「預測發展」相關的內容。,500455
3,k3,1152,預測發展,chinese,閱讀理解,故事理解,K3,能根據短文或故事推斷與「預測發展」相關的原因、次序或主旨。,500456
1,k1,1153,重複句式,chinese,閱讀理解,兒歌與韻文,K1,能閱讀並找出與「重複句式」相關的明顯資料。,500457
2,k1,1153,重複句式,chinese,閱讀理解,兒歌與韻文,K1,能根據圖文或短文理解與「重複句式」相關的內容。,500458
3,k1,1153,重複句式,chinese,閱讀理解,兒歌與韻文,K1,能根據短文或故事推斷與「重複句式」相關的原因、次序或主旨。,500459
1,k1,1154,押韻感知,chinese,閱讀理解,兒歌與韻文,K1,能閱讀並找出與「押韻感知」相關的明顯資料。,500460
2,k1,1154,押韻感知,chinese,閱讀理解,兒歌與韻文,K1,能根據圖文或短文理解與「押韻感知」相關的內容。,500461
3,k1,1154,押韻感知,chinese,閱讀理解,兒歌與韻文,K1,能根據短文或故事推斷與「押韻感知」相關的原因、次序或主旨。,500462
1,k2,1155,詞語替換,chinese,閱讀理解,兒歌與韻文,K2,能閱讀並找出與「詞語替換」相關的明顯資料。,500463
2,k2,1155,詞語替換,chinese,閱讀理解,兒歌與韻文,K2,能根據圖文或短文理解與「詞語替換」相關的內容。,500464
3,k2,1155,詞語替換,chinese,閱讀理解,兒歌與韻文,K2,能根據短文或故事推斷與「詞語替換」相關的原因、次序或主旨。,500465
1,k2,1156,內容配圖,chinese,閱讀理解,兒歌與韻文,K2,能閱讀並找出與「內容配圖」相關的明顯資料。,500466
2,k2,1156,內容配圖,chinese,閱讀理解,兒歌與韻文,K2,能根據圖文或短文理解與「內容配圖」相關的內容。,500467
3,k2,1156,內容配圖,chinese,閱讀理解,兒歌與韻文,K2,能根據短文或故事推斷與「內容配圖」相關的原因、次序或主旨。,500468
1,k3,1157,句意理解,chinese,閱讀理解,兒歌與韻文,K3,能閱讀並找出與「句意理解」相關的明顯資料。,500469
2,k3,1157,句意理解,chinese,閱讀理解,兒歌與韻文,K3,能根據圖文或短文理解與「句意理解」相關的內容。,500470
3,k3,1157,句意理解,chinese,閱讀理解,兒歌與韻文,K3,能根據短文或故事推斷與「句意理解」相關的原因、次序或主旨。,500471
1,k3,1158,節奏與重複結構,chinese,閱讀理解,兒歌與韻文,K3,能閱讀並找出與「節奏與重複結構」相關的明顯資料。,500472
2,k3,1158,節奏與重複結構,chinese,閱讀理解,兒歌與韻文,K3,能根據圖文或短文理解與「節奏與重複結構」相關的內容。,500473
3,k3,1158,節奏與重複結構,chinese,閱讀理解,兒歌與韻文,K3,能根據短文或故事推斷與「節奏與重複結構」相關的原因、次序或主旨。,500474
1,k1,1159,物件標籤,chinese,閱讀理解,生活文本,K1,能閱讀並找出與「物件標籤」相關的明顯資料。,500475
2,k1,1159,物件標籤,chinese,閱讀理解,生活文本,K1,能根據圖文或短文理解與「物件標籤」相關的內容。,500476
3,k1,1159,物件標籤,chinese,閱讀理解,生活文本,K1,能根據短文或故事推斷與「物件標籤」相關的原因、次序或主旨。,500477
1,k1,1160,圖像標籤,chinese,閱讀理解,生活文本,K1,能閱讀並找出與「圖像標籤」相關的明顯資料。,500478
2,k1,1160,圖像標籤,chinese,閱讀理解,生活文本,K1,能根據圖文或短文理解與「圖像標籤」相關的內容。,500479
3,k1,1160,圖像標籤,chinese,閱讀理解,生活文本,K1,能根據短文或故事推斷與「圖像標籤」相關的原因、次序或主旨。,500480
1,k2,1161,生日卡,chinese,閱讀理解,生活文本,K2,能閱讀並找出與「生日卡」相關的明顯資料。,500481
2,k2,1161,生日卡,chinese,閱讀理解,生活文本,K2,能根據圖文或短文理解與「生日卡」相關的內容。,500482
3,k2,1161,生日卡,chinese,閱讀理解,生活文本,K2,能根據短文或故事推斷與「生日卡」相關的原因、次序或主旨。,500483
1,k2,1162,邀請卡,chinese,閱讀理解,生活文本,K2,能閱讀並找出與「邀請卡」相關的明顯資料。,500484
2,k2,1162,邀請卡,chinese,閱讀理解,生活文本,K2,能根據圖文或短文理解與「邀請卡」相關的內容。,500485
3,k2,1162,邀請卡,chinese,閱讀理解,生活文本,K2,能根據短文或故事推斷與「邀請卡」相關的原因、次序或主旨。,500486
1,k3,1163,簡單通告,chinese,閱讀理解,生活文本,K3,能閱讀並找出與「簡單通告」相關的明顯資料。,500487
2,k3,1163,簡單通告,chinese,閱讀理解,生活文本,K3,能根據圖文或短文理解與「簡單通告」相關的內容。,500488
3,k3,1163,簡單通告,chinese,閱讀理解,生活文本,K3,能根據短文或故事推斷與「簡單通告」相關的原因、次序或主旨。,500489
1,k3,1164,餐牌,chinese,閱讀理解,生活文本,K3,能閱讀並找出與「餐牌」相關的明顯資料。,500490
2,k3,1164,餐牌,chinese,閱讀理解,生活文本,K3,能根據圖文或短文理解與「餐牌」相關的內容。,500491
3,k3,1164,餐牌,chinese,閱讀理解,生活文本,K3,能根據短文或故事推斷與「餐牌」相關的原因、次序或主旨。,500492
1,k3,1165,指示牌,chinese,閱讀理解,生活文本,K3,能閱讀並找出與「指示牌」相關的明顯資料。,500493
2,k3,1165,指示牌,chinese,閱讀理解,生活文本,K3,能根據圖文或短文理解與「指示牌」相關的內容。,500494
3,k3,1165,指示牌,chinese,閱讀理解,生活文本,K3,能根據短文或故事推斷與「指示牌」相關的原因、次序或主旨。,500495
1,k1,1166,這是…,chinese,句子與書寫,基本句式,K1,能辨認、描寫或補充與「這是…」相關的基本句子或字詞。,500496
2,k1,1166,這是…,chinese,句子與書寫,基本句式,K1,能重組、填寫或選出與「這是…」相關的正確句子。,500497
3,k1,1166,這是…,chinese,句子與書寫,基本句式,K1,能按圖片或情境書寫與「這是…」相關的完整句或短段。,500498
1,k1,1167,我有…,chinese,句子與書寫,基本句式,K1,能辨認、描寫或補充與「我有…」相關的基本句子或字詞。,500499
2,k1,1167,我有…,chinese,句子與書寫,基本句式,K1,能重組、填寫或選出與「我有…」相關的正確句子。,500500
3,k1,1167,我有…,chinese,句子與書寫,基本句式,K1,能按圖片或情境書寫與「我有…」相關的完整句或短段。,500501
1,k1,1168,我是…,chinese,句子與書寫,基本句式,K1,能辨認、描寫或補充與「我是…」相關的基本句子或字詞。,500502
2,k1,1168,我是…,chinese,句子與書寫,基本句式,K1,能重組、填寫或選出與「我是…」相關的正確句子。,500503
3,k1,1168,我是…,chinese,句子與書寫,基本句式,K1,能按圖片或情境書寫與「我是…」相關的完整句或短段。,500504
1,k2,1169,…在…,chinese,句子與書寫,基本句式,K2,能辨認、描寫或補充與「…在…」相關的基本句子或字詞。,500505
2,k2,1169,…在…,chinese,句子與書寫,基本句式,K2,能重組、填寫或選出與「…在…」相關的正確句子。,500506
3,k2,1169,…在…,chinese,句子與書寫,基本句式,K2,能按圖片或情境書寫與「…在…」相關的完整句或短段。,500507
1,k2,1170,我喜歡…,chinese,句子與書寫,基本句式,K2,能辨認、描寫或補充與「我喜歡…」相關的基本句子或字詞。,500508
2,k2,1170,我喜歡…,chinese,句子與書寫,基本句式,K2,能重組、填寫或選出與「我喜歡…」相關的正確句子。,500509
3,k2,1170,我喜歡…,chinese,句子與書寫,基本句式,K2,能按圖片或情境書寫與「我喜歡…」相關的完整句或短段。,500510
1,k2,1171,…有…,chinese,句子與書寫,基本句式,K2,能辨認、描寫或補充與「…有…」相關的基本句子或字詞。,500511
2,k2,1171,…有…,chinese,句子與書寫,基本句式,K2,能重組、填寫或選出與「…有…」相關的正確句子。,500512
3,k2,1171,…有…,chinese,句子與書寫,基本句式,K2,能按圖片或情境書寫與「…有…」相關的完整句或短段。,500513
1,k3,1172,因為…所以…,chinese,句子與書寫,基本句式,K3,能辨認、描寫或補充與「因為…所以…」相關的基本句子或字詞。,500514
2,k3,1172,因為…所以…,chinese,句子與書寫,基本句式,K3,能重組、填寫或選出與「因為…所以…」相關的正確句子。,500515
3,k3,1172,因為…所以…,chinese,句子與書寫,基本句式,K3,能按圖片或情境書寫與「因為…所以…」相關的完整句或短段。,500516
1,k3,1173,先…再…,chinese,句子與書寫,基本句式,K3,能辨認、描寫或補充與「先…再…」相關的基本句子或字詞。,500517
2,k3,1173,先…再…,chinese,句子與書寫,基本句式,K3,能重組、填寫或選出與「先…再…」相關的正確句子。,500518
3,k3,1173,先…再…,chinese,句子與書寫,基本句式,K3,能按圖片或情境書寫與「先…再…」相關的完整句或短段。,500519
1,k3,1174,一邊…一邊…,chinese,句子與書寫,基本句式,K3,能辨認、描寫或補充與「一邊…一邊…」相關的基本句子或字詞。,500520
2,k3,1174,一邊…一邊…,chinese,句子與書寫,基本句式,K3,能重組、填寫或選出與「一邊…一邊…」相關的正確句子。,500521
3,k3,1174,一邊…一邊…,chinese,句子與書寫,基本句式,K3,能按圖片或情境書寫與「一邊…一邊…」相關的完整句或短段。,500522
1,k1,1175,句號,chinese,句子與書寫,問句與標點,K1,能辨認、描寫或補充與「句號」相關的基本句子或字詞。,500523
2,k1,1175,句號,chinese,句子與書寫,問句與標點,K1,能重組、填寫或選出與「句號」相關的正確句子。,500524
3,k1,1175,句號,chinese,句子與書寫,問句與標點,K1,能按圖片或情境書寫與「句號」相關的完整句或短段。,500525
1,k1,1176,問號,chinese,句子與書寫,問句與標點,K1,能辨認、描寫或補充與「問號」相關的基本句子或字詞。,500526
2,k1,1176,問號,chinese,句子與書寫,問句與標點,K1,能重組、填寫或選出與「問號」相關的正確句子。,500527
3,k1,1176,問號,chinese,句子與書寫,問句與標點,K1,能按圖片或情境書寫與「問號」相關的完整句或短段。,500528
1,k2,1177,逗號,chinese,句子與書寫,問句與標點,K2,能辨認、描寫或補充與「逗號」相關的基本句子或字詞。,500529
2,k2,1177,逗號,chinese,句子與書寫,問句與標點,K2,能重組、填寫或選出與「逗號」相關的正確句子。,500530
3,k2,1177,逗號,chinese,句子與書寫,問句與標點,K2,能按圖片或情境書寫與「逗號」相關的完整句或短段。,500531
1,k2,1178,感嘆號,chinese,句子與書寫,問句與標點,K2,能辨認、描寫或補充與「感嘆號」相關的基本句子或字詞。,500532
2,k2,1178,感嘆號,chinese,句子與書寫,問句與標點,K2,能重組、填寫或選出與「感嘆號」相關的正確句子。,500533
3,k2,1178,感嘆號,chinese,句子與書寫,問句與標點,K2,能按圖片或情境書寫與「感嘆號」相關的完整句或短段。,500534
1,k2,1179,問句配答句,chinese,句子與書寫,問句與標點,K2,能辨認、描寫或補充與「問句配答句」相關的基本句子或字詞。,500535
2,k2,1179,問句配答句,chinese,句子與書寫,問句與標點,K2,能重組、填寫或選出與「問句配答句」相關的正確句子。,500536
3,k2,1179,問句配答句,chinese,句子與書寫,問句與標點,K2,能按圖片或情境書寫與「問句配答句」相關的完整句或短段。,500537
1,k3,1180,標點選擇,chinese,句子與書寫,問句與標點,K3,能辨認、描寫或補充與「標點選擇」相關的基本句子或字詞。,500538
2,k3,1180,標點選擇,chinese,句子與書寫,問句與標點,K3,能重組、填寫或選出與「標點選擇」相關的正確句子。,500539
3,k3,1180,標點選擇,chinese,句子與書寫,問句與標點,K3,能按圖片或情境書寫與「標點選擇」相關的完整句或短段。,500540
1,k3,1181,對話句,chinese,句子與書寫,問句與標點,K3,能辨認、描寫或補充與「對話句」相關的基本句子或字詞。,500541
2,k3,1181,對話句,chinese,句子與書寫,問句與標點,K3,能重組、填寫或選出與「對話句」相關的正確句子。,500542
3,k3,1181,對話句,chinese,句子與書寫,問句與標點,K3,能按圖片或情境書寫與「對話句」相關的完整句或短段。,500543
1,k3,1182,完整句判斷,chinese,句子與書寫,問句與標點,K3,能辨認、描寫或補充與「完整句判斷」相關的基本句子或字詞。,500544
2,k3,1182,完整句判斷,chinese,句子與書寫,問句與標點,K3,能重組、填寫或選出與「完整句判斷」相關的正確句子。,500545
3,k3,1182,完整句判斷,chinese,句子與書寫,問句與標點,K3,能按圖片或情境書寫與「完整句判斷」相關的完整句或短段。,500546
1,k1,1183,詞語補句,chinese,句子與書寫,句子重組與補充,K1,能辨認、描寫或補充與「詞語補句」相關的基本句子或字詞。,500547
2,k1,1183,詞語補句,chinese,句子與書寫,句子重組與補充,K1,能重組、填寫或選出與「詞語補句」相關的正確句子。,500548
3,k1,1183,詞語補句,chinese,句子與書寫,句子重組與補充,K1,能按圖片或情境書寫與「詞語補句」相關的完整句或短段。,500549
1,k1,1184,圖片補句,chinese,句子與書寫,句子重組與補充,K1,能辨認、描寫或補充與「圖片補句」相關的基本句子或字詞。,500550
2,k1,1184,圖片補句,chinese,句子與書寫,句子重組與補充,K1,能重組、填寫或選出與「圖片補句」相關的正確句子。,500551
3,k1,1184,圖片補句,chinese,句子與書寫,句子重組與補充,K1,能按圖片或情境書寫與「圖片補句」相關的完整句或短段。,500552
1,k2,1185,詞語排句,chinese,句子與書寫,句子重組與補充,K2,能辨認、描寫或補充與「詞語排句」相關的基本句子或字詞。,500553
2,k2,1185,詞語排句,chinese,句子與書寫,句子重組與補充,K2,能重組、填寫或選出與「詞語排句」相關的正確句子。,500554
3,k2,1185,詞語排句,chinese,句子與書寫,句子重組與補充,K2,能按圖片或情境書寫與「詞語排句」相關的完整句或短段。,500555
1,k2,1186,句子配圖,chinese,句子與書寫,句子重組與補充,K2,能辨認、描寫或補充與「句子配圖」相關的基本句子或字詞。,500556
2,k2,1186,句子配圖,chinese,句子與書寫,句子重組與補充,K2,能重組、填寫或選出與「句子配圖」相關的正確句子。,500557
3,k2,1186,句子配圖,chinese,句子與書寫,句子重組與補充,K2,能按圖片或情境書寫與「句子配圖」相關的完整句或短段。,500558
1,k3,1187,句子重組,chinese,句子與書寫,句子重組與補充,K3,能辨認、描寫或補充與「句子重組」相關的基本句子或字詞。,500559
2,k3,1187,句子重組,chinese,句子與書寫,句子重組與補充,K3,能重組、填寫或選出與「句子重組」相關的正確句子。,500560
3,k3,1187,句子重組,chinese,句子與書寫,句子重組與補充,K3,能按圖片或情境書寫與「句子重組」相關的完整句或短段。,500561
1,k3,1188,擴寫句子,chinese,句子與書寫,句子重組與補充,K3,能辨認、描寫或補充與「擴寫句子」相關的基本句子或字詞。,500562
2,k3,1188,擴寫句子,chinese,句子與書寫,句子重組與補充,K3,能重組、填寫或選出與「擴寫句子」相關的正確句子。,500563
3,k3,1188,擴寫句子,chinese,句子與書寫,句子重組與補充,K3,能按圖片或情境書寫與「擴寫句子」相關的完整句或短段。,500564
1,k3,1189,連句成段,chinese,句子與書寫,句子重組與補充,K3,能辨認、描寫或補充與「連句成段」相關的基本句子或字詞。,500565
2,k3,1189,連句成段,chinese,句子與書寫,句子重組與補充,K3,能重組、填寫或選出與「連句成段」相關的正確句子。,500566
3,k3,1189,連句成段,chinese,句子與書寫,句子重組與補充,K3,能按圖片或情境書寫與「連句成段」相關的完整句或短段。,500567
1,k1,1190,直線描寫,chinese,句子與書寫,書寫準備,K1,能辨認、描寫或補充與「直線描寫」相關的基本句子或字詞。,500568
2,k1,1190,直線描寫,chinese,句子與書寫,書寫準備,K1,能重組、填寫或選出與「直線描寫」相關的正確句子。,500569
3,k1,1190,直線描寫,chinese,句子與書寫,書寫準備,K1,能按圖片或情境書寫與「直線描寫」相關的完整句或短段。,500570
1,k1,1191,曲線描寫,chinese,句子與書寫,書寫準備,K1,能辨認、描寫或補充與「曲線描寫」相關的基本句子或字詞。,500571
2,k1,1191,曲線描寫,chinese,句子與書寫,書寫準備,K1,能重組、填寫或選出與「曲線描寫」相關的正確句子。,500572
3,k1,1191,曲線描寫,chinese,句子與書寫,書寫準備,K1,能按圖片或情境書寫與「曲線描寫」相關的完整句或短段。,500573
1,k1,1192,圓形與折線,chinese,句子與書寫,書寫準備,K1,能辨認、描寫或補充與「圓形與折線」相關的基本句子或字詞。,500574
2,k1,1192,圓形與折線,chinese,句子與書寫,書寫準備,K1,能重組、填寫或選出與「圓形與折線」相關的正確句子。,500575
3,k1,1192,圓形與折線,chinese,句子與書寫,書寫準備,K1,能按圖片或情境書寫與「圓形與折線」相關的完整句或短段。,500576
1,k2,1193,筆畫描寫,chinese,句子與書寫,書寫準備,K2,能辨認、描寫或補充與「筆畫描寫」相關的基本句子或字詞。,500577
2,k2,1193,筆畫描寫,chinese,句子與書寫,書寫準備,K2,能重組、填寫或選出與「筆畫描寫」相關的正確句子。,500578
3,k2,1193,筆畫描寫,chinese,句子與書寫,書寫準備,K2,能按圖片或情境書寫與「筆畫描寫」相關的完整句或短段。,500579
1,k2,1194,字格位置,chinese,句子與書寫,書寫準備,K2,能辨認、描寫或補充與「字格位置」相關的基本句子或字詞。,500580
2,k2,1194,字格位置,chinese,句子與書寫,書寫準備,K2,能重組、填寫或選出與「字格位置」相關的正確句子。,500581
3,k2,1194,字格位置,chinese,句子與書寫,書寫準備,K2,能按圖片或情境書寫與「字格位置」相關的完整句或短段。,500582
1,k2,1195,筆順跟寫,chinese,句子與書寫,書寫準備,K2,能辨認、描寫或補充與「筆順跟寫」相關的基本句子或字詞。,500583
2,k2,1195,筆順跟寫,chinese,句子與書寫,書寫準備,K2,能重組、填寫或選出與「筆順跟寫」相關的正確句子。,500584
3,k2,1195,筆順跟寫,chinese,句子與書寫,書寫準備,K2,能按圖片或情境書寫與「筆順跟寫」相關的完整句或短段。,500585
1,k3,1196,常用字抄寫,chinese,句子與書寫,書寫準備,K3,能辨認、描寫或補充與「常用字抄寫」相關的基本句子或字詞。,500586
2,k3,1196,常用字抄寫,chinese,句子與書寫,書寫準備,K3,能重組、填寫或選出與「常用字抄寫」相關的正確句子。,500587
3,k3,1196,常用字抄寫,chinese,句子與書寫,書寫準備,K3,能按圖片或情境書寫與「常用字抄寫」相關的完整句或短段。,500588
1,k3,1197,詞語抄寫,chinese,句子與書寫,書寫準備,K3,能辨認、描寫或補充與「詞語抄寫」相關的基本句子或字詞。,500589
2,k3,1197,詞語抄寫,chinese,句子與書寫,書寫準備,K3,能重組、填寫或選出與「詞語抄寫」相關的正確句子。,500590
3,k3,1197,詞語抄寫,chinese,句子與書寫,書寫準備,K3,能按圖片或情境書寫與「詞語抄寫」相關的完整句或短段。,500591
1,k3,1198,短句抄寫,chinese,句子與書寫,書寫準備,K3,能辨認、描寫或補充與「短句抄寫」相關的基本句子或字詞。,500592
2,k3,1198,短句抄寫,chinese,句子與書寫,書寫準備,K3,能重組、填寫或選出與「短句抄寫」相關的正確句子。,500593
3,k3,1198,短句抄寫,chinese,句子與書寫,書寫準備,K3,能按圖片或情境書寫與「短句抄寫」相關的完整句或短段。,500594
1,k1,1199,看圖選字,chinese,句子與書寫,看圖寫/選,K1,能辨認、描寫或補充與「看圖選字」相關的基本句子或字詞。,500595
2,k1,1199,看圖選字,chinese,句子與書寫,看圖寫/選,K1,能重組、填寫或選出與「看圖選字」相關的正確句子。,500596
3,k1,1199,看圖選字,chinese,句子與書寫,看圖寫/選,K1,能按圖片或情境書寫與「看圖選字」相關的完整句或短段。,500597
1,k2,1200,看圖選詞,chinese,句子與書寫,看圖寫/選,K2,能辨認、描寫或補充與「看圖選詞」相關的基本句子或字詞。,500598
2,k2,1200,看圖選詞,chinese,句子與書寫,看圖寫/選,K2,能重組、填寫或選出與「看圖選詞」相關的正確句子。,500599
3,k2,1200,看圖選詞,chinese,句子與書寫,看圖寫/選,K2,能按圖片或情境書寫與「看圖選詞」相關的完整句或短段。,500600
1,k2,1201,看圖補詞,chinese,句子與書寫,看圖寫/選,K2,能辨認、描寫或補充與「看圖補詞」相關的基本句子或字詞。,500601
2,k2,1201,看圖補詞,chinese,句子與書寫,看圖寫/選,K2,能重組、填寫或選出與「看圖補詞」相關的正確句子。,500602
3,k2,1201,看圖補詞,chinese,句子與書寫,看圖寫/選,K2,能按圖片或情境書寫與「看圖補詞」相關的完整句或短段。,500603
1,k3,1202,看圖填句,chinese,句子與書寫,看圖寫/選,K3,能辨認、描寫或補充與「看圖填句」相關的基本句子或字詞。,500604
2,k3,1202,看圖填句,chinese,句子與書寫,看圖寫/選,K3,能重組、填寫或選出與「看圖填句」相關的正確句子。,500605
3,k3,1202,看圖填句,chinese,句子與書寫,看圖寫/選,K3,能按圖片或情境書寫與「看圖填句」相關的完整句或短段。,500606
1,k3,1203,看圖寫一句,chinese,句子與書寫,看圖寫/選,K3,能辨認、描寫或補充與「看圖寫一句」相關的基本句子或字詞。,500607
2,k3,1203,看圖寫一句,chinese,句子與書寫,看圖寫/選,K3,能重組、填寫或選出與「看圖寫一句」相關的正確句子。,500608
3,k3,1203,看圖寫一句,chinese,句子與書寫,看圖寫/選,K3,能按圖片或情境書寫與「看圖寫一句」相關的完整句或短段。,500609
1,k3,1204,看圖寫兩句,chinese,句子與書寫,看圖寫/選,K3,能辨認、描寫或補充與「看圖寫兩句」相關的基本句子或字詞。,500610
2,k3,1204,看圖寫兩句,chinese,句子與書寫,看圖寫/選,K3,能重組、填寫或選出與「看圖寫兩句」相關的正確句子。,500611
3,k3,1204,看圖寫兩句,chinese,句子與書寫,看圖寫/選,K3,能按圖片或情境書寫與「看圖寫兩句」相關的完整句或短段。,500612`;

function parseChineseTaxonomyCsv(): ChineseTaxonomyCsvRow[] {
  const [headerLine, ...lines] = CHINESE_TAXONOMY_CSV.replace(/^\uFEFF/, '')
    .trim()
    .split(/\r?\n/);
  const headers = headerLine.split(',');
  return lines.map((line) => {
    const values = line.split(',');
    const record = headers.reduce<Record<string, string>>((acc, header, index) => {
      acc[header] = values[index] || '';
      return acc;
    }, {});

    return {
      difficulty: record.difficulty,
      targetGrade: record.target_grade,
      topicTypeId: record.topic_type_id,
      topic: record.topic,
      subject: record.subject,
      learningDomain: record.learning_domain,
      learningUnit: record.learning_unit,
      topicGrade: record.topic_grade,
      performanceIndicator: record.performance_indicator,
      id: record.id
    };
  });
}

function makeNode(
  id: string,
  level: TaxonomyNode['level'],
  name: string,
  code: string,
  description: string,
  children: TaxonomyNode[] = []
): TaxonomyNode {
  return { id, level, name, code, description, children };
}

function buildChineseTaxonomySubject(): TaxonomySubject {
  const rows = parseChineseTaxonomyCsv();
  const areas: TaxonomyNode[] = [];
  const areaByName = new Map<string, TaxonomyNode>();
  const unitByPath = new Map<string, TaxonomyNode>();
  const topicRowsByPath = new Map<string, ChineseTaxonomyCsvRow[]>();

  rows.forEach((row) => {
    const areaName = row.learningDomain.trim();
    const unitName = row.learningUnit.trim();
    const topicName = row.topic.trim();
    const areaKey = areaName;
    const unitKey = `${areaName}>${unitName}`;
    const topicKey = `${unitKey}>${topicName}`;

    if (!areaByName.has(areaKey)) {
      const area = makeNode(
        `area-chinese-${areaByName.size + 1}`,
        'area',
        areaName,
        `CHI-${areaByName.size + 1}`,
        '',
        []
      );
      areaByName.set(areaKey, area);
      areas.push(area);
    }

    if (!unitByPath.has(unitKey)) {
      const area = areaByName.get(areaKey)!;
      const unit = makeNode(
        `unit-chinese-${unitByPath.size + 1}`,
        'unit',
        unitName,
        `${area.code}-${area.children.length + 1}`,
        '',
        []
      );
      unitByPath.set(unitKey, unit);
      area.children.push(unit);
    }

    const topicRows = topicRowsByPath.get(topicKey) || [];
    topicRows.push(row);
    topicRowsByPath.set(topicKey, topicRows);
  });

  topicRowsByPath.forEach((topicRows, topicKey) => {
    const [areaName, unitName, topicName] = topicKey.split('>');
    const unit = unitByPath.get(`${areaName}>${unitName}`);
    if (!unit) return;

    const sortedRows = [...topicRows].sort((a, b) => Number(a.difficulty) - Number(b.difficulty));
    const first = sortedRows[0];
    unit.children.push(
      makeNode(
        `category-chinese-${first.topicTypeId}`,
        'category',
        topicName,
        first.topicTypeId,
        sortedRows
          .map(
            (row) =>
              `${row.topicGrade || row.targetGrade.toUpperCase()} 難度 ${row.difficulty}: ${
                row.performanceIndicator
              }`
          )
          .join('\n'),
        []
      )
    );
  });

  return makeNode(
    'subject-chinese',
    'subject',
    'Chinese',
    'CHI',
    '中文 K1-K3 學習目標分類架構。',
    areas
  ) as TaxonomySubject;
}

export const chineseTaxonomySubject = buildChineseTaxonomySubject();
